import "./src/styles/global.css";
export const shouldUpdateScroll = () => {
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
  return false;
};
export const onClientEntry = () => {
  if (typeof window !== "undefined" && !window.algoliasearch) {
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/algoliasearch@4/dist/algoliasearch-lite.umd.js";
    script.async = true;
    document.head.appendChild(script);
  }
};
